import {
  EsignError,
  QuestionsChallengeAction,
  QuestionsChallengeActionError,
} from "@interfaces";
import { AxiosError } from "axios";
import { getQuestionsChallengeErrorDisplay } from "../constants/questionsChallengeErrorMessages";
import {
  ENROLMENT_STEP,
  ENROLMENT_STEP_STATUS,
} from "@contexts/EnrolmentStatusContext";

export interface ErrorType extends AxiosError {
  error: {
    name: string;
    message: string;
    code?: string;
    action?: QuestionsChallengeAction;
  };
  message: string;
  nextStep?: ENROLMENT_STEP;
  nextStepStatus?: ENROLMENT_STEP_STATUS;
}

export const onQuestionChallengeAxiosErrorInterpreter = (
  error: AxiosError<ErrorType>,
) => {
  const status = error.response?.status;
  const errorData = error.response?.data?.error;
  const message = error.response?.data?.message ?? errorData?.message;
  const nameKey = message === "exceededMaxRetries" ? message : errorData?.name;
  const action = message === "exceededMaxRetries" ? "block" : errorData?.action;
  const code = errorData?.code;
  const nextStep = error.response?.data?.nextStep;
  const nextStepStatus = error.response?.data?.nextStepStatus;

  console.error("Error when generating questions challenges:", {
    status,
    name: nameKey,
    message,
    action,
    nextStep,
    nextStepStatus,
  });

  if (action) {
    const { name: displayName, description: displayDescription } =
      getQuestionsChallengeErrorDisplay(nameKey);
    throw new QuestionsChallengeActionError(
      message ?? "",
      displayName,
      action,
      displayDescription,
      code,
      nextStep,
      nextStepStatus,
    );
  }

  if (nameKey === "EsignError") {
    throw new EsignError(message ?? "");
  }
  throw error;
};
